import React, { useEffect, useState } from 'react';
import {
  adminLogin,
  clearStoredAdminToken,
  getAdminMe,
  getStoredAdminToken,
  setStoredAdminToken,
} from '../services/adminAuthApi';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  const [statusType, setStatusType] = useState('');

  useEffect(() => {
    let mounted = true;

    const validateSession = async () => {
      const token = getStoredAdminToken();
      if (!token) return;

      try {
        const me = await getAdminMe(token);
        if (mounted) {
          setAdmin(me);
        }
      } catch (error) {
        clearStoredAdminToken();
      }
    };

    validateSession();
    return () => {
      mounted = false;
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatusMessage('');
    setStatusType('');

    try {
      const data = await adminLogin({ email, password });
      setStoredAdminToken(data.token);
      setAdmin(data.admin);
      setPassword('');
      setStatusType('success');
      setStatusMessage('Sesión iniciada correctamente.');
    } catch (error) {
      setStatusType('error');
      setStatusMessage(error.message || 'No se pudo iniciar sesión.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    clearStoredAdminToken();
    setAdmin(null);
    setStatusType('success');
    setStatusMessage('Sesión cerrada.');
  };

  return (
    <section className="admin-auth-page">
      <div className="admin-auth-card">
        <h1>Acceso Administrador</h1>
        {!admin ? (
          <>
            <p>Inicia sesión para administrar productos desde el panel interno.</p>
            <form className="admin-auth-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <label htmlFor="admin-email">Correo</label>
                <input
                  id="admin-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@verissa.mx"
                />
              </div>
              <div className="form-row">
                <label htmlFor="admin-password">Contraseña</label>
                <input
                  id="admin-password"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Tu contraseña"
                />
              </div>
              <button type="submit" className="admin-auth-btn" disabled={loading}>
                {loading ? 'Ingresando...' : 'Iniciar sesión'}
              </button>
            </form>
          </>
        ) : (
          <>
            <p>
              Sesión activa como <strong>{admin.email}</strong>.
            </p>
            <div className="admin-auth-actions">
              <button
                type="button"
                className="admin-auth-btn"
                onClick={() => {
                  window.location.hash = 'admin';
                }}
              >
                Ir al panel
              </button>
              <button
                type="button"
                className="admin-auth-btn secondary"
                onClick={handleLogout}
              >
                Cerrar sesión
              </button>
            </div>
          </>
        )}
        {statusMessage && (
          <p className={`admin-auth-status ${statusType}`}>{statusMessage}</p>
        )}
      </div>
    </section>
  );
};

export default AdminLogin;
